// Apparel OS brand logo — kept in sync with apparel-os.com.
export function Logo({ className = "h-8 w-8" }) {
  return (
    <svg className={className} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="64" height="64" rx="10" fill="#0A0A0A" />
      <text x="16" y="44" fontFamily="Georgia, serif" fontSize="30" fontWeight="500" textAnchor="middle" fill="#F9F9F7">
        A
      </text>
      <g transform="translate(31 0) skewX(-12)">
        <text x="0" y="44" fontFamily="Georgia, serif" fontSize="30" fontWeight="300" fontStyle="italic" fill="#F9F9F7">
          OS
        </text>
      </g>
      <circle cx="55" cy="14" r="3.2" fill="#C2A878" />
    </svg>
  );
}

export function LogoWordmark({ className = "" }) {
  return (
    <span className={`inline-flex items-baseline gap-1 ${className}`} aria-label="Apparel OS">
      <span className="font-serif text-xl tracking-tight font-normal text-foreground md:text-2xl">Apparel</span>
      <span className="font-serif text-xl tracking-tight italic font-light text-foreground/80 md:text-2xl">OS</span>
      <span className="ml-1.5 inline-block h-1.5 w-1.5 -translate-y-1.5 rounded-full bg-gold" aria-hidden="true" />
    </span>
  );
}
